export default __webpack_public_path__ + "static/media/HOL.8706f8a5.svg";